import { CREDIT_SCORE_THRESHOLDS, MAX_CREDIT_SCORE, MIN_CREDIT_SCORE } from 'enums/CreditScoreCategory';

export enum CreditScoreColor {
  Poor = 'var(--credit-poor)',
  Fair = 'var(--credit-fair)',
  Good = 'var(--credit-good)',
  VeryGood = 'var(--credit-very-good)',
  Excellent = 'var(--credit-excellent)',
}

export const getCreditScoreFillColor = (score: number): CreditScoreColor => {
  if (score < CREDIT_SCORE_THRESHOLDS.POOR) return CreditScoreColor.Poor;
  if (score < CREDIT_SCORE_THRESHOLDS.FAIR) return CreditScoreColor.Fair;
  if (score < CREDIT_SCORE_THRESHOLDS.GOOD) return CreditScoreColor.Good;
  if (score < CREDIT_SCORE_THRESHOLDS.VERY_GOOD) return CreditScoreColor.VeryGood;
  return CreditScoreColor.Excellent;
};

export const getCreditScorePathFillPercentage = (pathIndex: number, creditScore: number): number => {
  const ranges = [
    { min: MIN_CREDIT_SCORE, max: CREDIT_SCORE_THRESHOLDS.POOR },
    { min: CREDIT_SCORE_THRESHOLDS.POOR, max: CREDIT_SCORE_THRESHOLDS.FAIR },
    { min: CREDIT_SCORE_THRESHOLDS.FAIR, max: CREDIT_SCORE_THRESHOLDS.GOOD },
    { min: CREDIT_SCORE_THRESHOLDS.GOOD, max: CREDIT_SCORE_THRESHOLDS.VERY_GOOD },
    { min: CREDIT_SCORE_THRESHOLDS.VERY_GOOD, max: MAX_CREDIT_SCORE },
  ];

  const range = ranges[pathIndex];
  if (!range) return 0;

  if (creditScore === range.min) return 1;
  if (creditScore < range.min) return 0;
  if (creditScore >= range.max) return 100;

  const rangeSize = range.max - range.min;
  const scoreInRange = creditScore - range.min;
  return (scoreInRange / rangeSize) * 100;
};

export interface CreditScorePath {
  path: string;
  stroke: CreditScoreColor;
}

export const CREDIT_SCORE_PATHS: CreditScorePath[] = [
  {
    path:
      'M23.7098 99.1838C14.4117 89.8856 8.82578 77.5143 8.00011 64.3907L8.53905 64.3568C9.35646 77.3491 14.8865 89.5968 24.0916 98.8019L23.7098 99.1838Z',
    stroke: CreditScoreColor.Poor,
  },
  {
    path:
      'M9.07359 49.7728C11.8075 36.9106 19.1407 25.4879 29.6974 17.6479L30.0194 18.0814C19.5683 25.8431 12.3084 37.1515 9.60179 49.885L9.07359 49.7728Z',
    stroke: CreditScoreColor.Fair,
  },
  {
    path:
      'M42.5417 10.5867C55.0908 5.7695 68.9854 5.80588 81.5091 10.6887L81.313 11.1918C68.9145 6.35782 55.1588 6.32181 42.7352 11.0908L42.5417 10.5867Z',
    stroke: CreditScoreColor.Good,
  },
  {
    path:
      'M94.3916 17.8737C104.893 25.7873 112.147 37.2608 114.791 50.1418L114.262 50.2504C111.644 37.4982 104.463 26.1394 94.0666 18.305L94.3916 17.8737Z',
    stroke: CreditScoreColor.VeryGood,
  },
  {
    path:
      'M115.762 64.7668C114.845 77.8844 109.173 90.2164 99.8098 99.4494L99.4307 99.0649C108.7 89.9243 114.315 77.7155 115.223 64.7292L115.762 64.7668Z',
    stroke: CreditScoreColor.Excellent,
  },
];
